import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import VueRouter from 'vue-router'
import './plugins/bootstrap-vue'
import App from './App.vue'
import 'vue-material-design-icons/styles.css';

// Icons
import ClockIcon from 'vue-material-design-icons/Clock.vue';
import BullhornIcon from 'vue-material-design-icons/Bullhorn.vue';
import CarIcon from 'vue-material-design-icons/Car.vue';

// Pages
import Monitor from './components/Monitor.vue'
import Connect from './components/Connect.vue'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.component('clock-icon', ClockIcon);
Vue.component('car-icon', CarIcon);
Vue.component('bullhorn-icon', BullhornIcon);

const routes = [
  { path: '/monitor', component: Monitor },
  { path: '/connect', component: Connect }
]

const router = new VueRouter({
  routes
})

new Vue({
  render: h => h(App),
  router: router
}).$mount('#app')
